import * as THREE from 'three';
import Application from '../Application';
import UIEventBus from '../UI/EventBus';
export default class Hitboxes {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.camera = this.application.camera;
        this.mouse = this.application.mouse;
        this.raycaster = new THREE.Raycaster();
        this.hitboxMeshes = [];
        this.hitboxActions = {};
        this.currentRadioTrack = 0;
        this.radioAudio = null;
        this.setupRaycaster();
        this.createAllHitboxes();
    }
    setupRaycaster() {
        // Trigger action on click
        window.addEventListener('mousedown', (event) => {
            // Only capture clicks if not focused inside the computer screen
            if (this.mouse.inComputer)
                return;
            // Calculate normalized device coordinates
            const ndcMouse = new THREE.Vector2((event.clientX / window.innerWidth) * 2 - 1, -(event.clientY / window.innerHeight) * 2 + 1);
            this.raycaster.setFromCamera(ndcMouse, this.camera.instance);
            const intersects = this.raycaster.intersectObjects(this.hitboxMeshes);
            if (intersects.length > 0) {
                const clickedMesh = intersects[0].object;
                const action = this.hitboxActions[clickedMesh.name];
                if (action) {
                    action();
                }
            }
        });
        // Set cursor pointer on hover
        window.addEventListener('mousemove', (event) => {
            if (this.mouse.inComputer) {
                document.body.style.cursor = 'auto';
                return;
            }
            const ndcMouse = new THREE.Vector2((event.clientX / window.innerWidth) * 2 - 1, -(event.clientY / window.innerHeight) * 2 + 1);
            this.raycaster.setFromCamera(ndcMouse, this.camera.instance);
            const intersects = this.raycaster.intersectObjects(this.hitboxMeshes);
            if (intersects.length > 0) {
                document.body.style.cursor = 'pointer';
            }
            else {
                document.body.style.cursor = 'auto';
            }
        });
    }
    createAllHitboxes() {
        // 1. Monitor Screen (Focus camera on screen)
        this.addHitbox('monitorHitbox', () => {
            this.camera.trigger('enterMonitor');
        }, new THREE.Vector3(0, 950, 255), new THREE.Vector3(1300, 1050, 200));
        // 2. Desk Lamp (Toggles Night Mode)
        this.addHitbox('lampHitbox', () => {
            // Toggle Night Mode
            const isNight = !this.application.world.environment['isNight'];
            UIEventBus.dispatch('nightModeToggle', isNight);
            // Play switch sound
            this.application.world.audioManager.playAudio('keyboardKeydown', {
                volume: 1.0,
                pitch: 5,
                position: new THREE.Vector3(-1600, 300, 800)
            });
        }, new THREE.Vector3(-1600, 300, 800), new THREE.Vector3(500, 800, 500));
        // 3. Coffee Mug (Plays slurp/steam sound)
        this.addHitbox('coffeeHitbox', () => {
            // Play slurp/click sound
            this.application.world.audioManager.playAudio('mouseDown', {
                volume: 0.9,
                pitch: -10,
                position: new THREE.Vector3(1670, 100, 900)
            });
            // Small visual steam pop can be triggered if desired
        }, new THREE.Vector3(1670, 100, 900), new THREE.Vector3(400, 400, 400));
        // 4. Keyboard (Plays keypress sounds)
        this.addHitbox('keyboardHitbox', () => {
            this.application.world.audioManager.playAudio('keyboardKeydown', {
                volume: 1.0,
                position: new THREE.Vector3(0, 100, 1300)
            });
        }, new THREE.Vector3(0, 100, 1300), new THREE.Vector3(1000, 200, 600));
        // 5. Speakers / Radio (Cycles playlist)
        this.addHitbox('speakerHitbox', () => {
            this.cycleRadio();
        }, new THREE.Vector3(-1100, 200, 600), new THREE.Vector3(400, 600, 400));
        // 6. Sticky Notes (Toggles Project Cards Modal)
        this.addHitbox('stickyNotesHitbox', () => {
            UIEventBus.dispatch('toggleProjects', true);
            this.application.world.audioManager.playAudio('mouseDown', {
                volume: 0.8,
                position: new THREE.Vector3(-900, 800, 400)
            });
        }, new THREE.Vector3(-900, 800, 400), new THREE.Vector3(300, 300, 100));
        // 7. Resume Folder (Toggles Resume Modal)
        this.addHitbox('resumeFolderHitbox', () => {
            UIEventBus.dispatch('toggleResume', true);
            this.application.world.audioManager.playAudio('mouseDown', {
                volume: 0.8,
                position: new THREE.Vector3(-1000, 100, 1200)
            });
        }, new THREE.Vector3(-1000, 100, 1200), new THREE.Vector3(500, 100, 500));
    }
    addHitbox(name, action, position, size) {
        // Hitbox geometry & invisible material
        const geometry = new THREE.BoxGeometry(size.x, size.y, size.z);
        const material = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.0, // Invisible in production
            depthWrite: false,
        });
        const mesh = new THREE.Mesh(geometry, material);
        mesh.name = name;
        mesh.position.copy(position);
        this.scene.add(mesh);
        this.hitboxMeshes.push(mesh);
        this.hitboxActions[name] = action;
    }
    cycleRadio() {
        // Toggle track
        this.currentRadioTrack = (this.currentRadioTrack + 1) % 4;
        // Play feedback click
        this.application.world.audioManager.playAudio('mouseUp', {
            volume: 0.7,
            position: new THREE.Vector3(-1100, 200, 600)
        });
        // Stop current audio if playing
        if (this.radioAudio) {
            this.radioAudio.pause();
            this.radioAudio = null;
        }
        if (this.currentRadioTrack > 0) {
            // Create & play new dynamic HTML5 Audio stream (so it is lazy-loaded)
            this.radioAudio = new Audio(`audio/radio/${this.currentRadioTrack}.mp3`);
            this.radioAudio.volume = 0.4;
            this.radioAudio.loop = true;
            this.radioAudio.play().catch(() => {
                console.log('Audio autoplay blocked by browser.');
            });
            console.log(`[Radio] Playing track ${this.currentRadioTrack}`);
        }
        else {
            console.log('[Radio] Turned off');
        }
    }
}
